// API-related functions for customer management
import api, { API_BASE_URL } from '../../../shared/utils/api';





// Fetch customers from API
export const fetchCustomers = async () => {
  try {
    console.log('🔍 Fetching customers...');
    // Backend route: /api/customerslist/accountant/customers
    const response = await api.get('/api/customerslist/accountant/customers');
    
    if (response.success && response.data) {
      console.log('✅ Customers fetched successfully:', response.data.length);
      return response.data;
    } else {
      console.error('❌ Failed to fetch customers:', response);
      return [];
    }
  } catch (error) {
    console.error('❌ Error fetching customers:', error);
    return [];
  }
};

// Fetch employees for a customer (syncEmpId=true → empId sync + ажилчдыг буцаана)
export const fetchEmployees = async (customerOid: string, syncEmpId = true) => {
  try {
    console.log('🔍 Fetching employees for customer OID:', customerOid);
    const url = `/api/customer-employees/${customerOid}${syncEmpId ? '?syncEmpId=true' : ''}`;
    const response = await api.get(url);
    
    if (response.success && response.employees) {
      console.log('✅ Employees fetched successfully:', response.employees.length);
      return response.employees;
    } else {
      console.error('❌ Failed to fetch employees:', response);
      return [];
    }
  } catch (error) {
    console.error('❌ Error fetching employees:', error);
    return [];
  }
};

// Fetch all employees for salary configuration
export const fetchAllEmployeesForSalaryConfig = async () => {
  try {
    console.log('🔍 Fetching all employees for salary configuration...');
    const response = await api.get('/api/customer-employees/all-for-salary-config');
    
    if (response.success && response.data) {
      console.log('✅ All employees for salary config fetched successfully:', response.data.length);
      return response.data;
    } else {
      console.error('❌ Failed to fetch all employees for salary config:', response);
      return [];
    }
  } catch (error) {
    console.error('❌ Error fetching all employees for salary config:', error);
    return [];
  }
};

// Fetch employees by customer
export const fetchEmployeesByCustomer = async (customerOid: string) => {
  try {
    console.log('🔍 Fetching employees for customer:', customerOid);
    const response = await api.get(`/api/customer-employees/by-customer/${customerOid}`);
    
    if (response.success && response.data) {
      console.log('✅ Employees by customer fetched successfully:', response.data.length);
      return response.data;
    } else {
      console.error('❌ Failed to fetch employees by customer:', response);
      return [];
    }
  } catch (error) {
    console.error('❌ Error fetching employees by customer:', error);
    return [];
  }
};

// Fetch employees with salary configuration (JOIN CustomerEmployee + CustomerEmployeeSalary)
export const fetchEmployeesWithSalaryConfig = async (customerOid: string, year: number) => {
  try {
    console.log('🔍 Fetching employees with salary config for customer:', customerOid, 'year:', year);
    const response = await api.get(`/api/customer-employee-salary/with-employee-info/${customerOid}/${year}`);
    
    if (response.success && response.data) {
      console.log('✅ Employees with salary config fetched successfully:', response.data.length);
      return response.data;
    } else {
      console.error('❌ Failed to fetch employees with salary config:', response);
      return [];
    }
  } catch (error) {
    console.error('❌ Error fetching employees with salary config:', error);
    return [];
  }
};

export const fetchSalarySheet = async (customerOid: string) => {
  try {
    console.log('🔍 Fetching salary sheet for customer OID:', customerOid);
    const response = await api.get(`/api/salary-sheet/${customerOid}`);
    
    if (response.success && response.salaryRecords) {
      console.log('✅ Salary sheet fetched successfully:', response.salaryRecords.length);
      return response.salaryRecords;
    } else {
      console.error('❌ Failed to fetch salary sheet:', response);
      return [];
    }
  } catch (error) {
    console.error('❌ Error fetching salary sheet:', error);
    return [];
  }
};


// Цалин бодолтын статус шалгах
export const checkPayrollStatus = async (year: number, month: number) => {
  try {
    console.log('📊 Checking payroll status for:', year, month);
    const response = await api.get(`/api/payroll/payroll-status/${year}/${month}`);
    
    if (response.success) {
      console.log('✅ Payroll status checked successfully:', response.data);
      return response.data;
    } else {
      console.error('❌ Failed to check payroll status:', response);
      return response;
    }
  } catch (error) {
    console.error('❌ Error checking payroll status:', error);
    return {
      success: false,
      message: 'Цалин бодолтын статус шалгахад алдаа гарлаа',
      error: error
    };
  }
};



// Check TIN code

// CustomerEmployeeSalary хүснэгтээс мэдээлэл авах (цалингийн тохиргоо)
export const fetchCustomerEmployeeSalaryData = async (year: number, month: number, customerOid?: string) => {
  try {
    console.log('🔍 Fetching CustomerEmployeeSalary data for:', year, month, customerOid);
    
    // Query parameter-ийг URL-д нэмэх
    let url = `/api/customer-employee-salary/data/${year}/${month}`;
    if (customerOid) {
      url += `?customerOid=${encodeURIComponent(customerOid)}`;
    }
    
    const response = await api.get(url);
    
    if (response.success && response.data) {
      console.log('✅ CustomerEmployeeSalary data fetched successfully:', response.data.length);
      return response.data;
    } else {
      console.error('❌ Failed to fetch CustomerEmployeeSalary data:', response);
      return [];
    }
  } catch (error) {
    console.error('❌ Error fetching CustomerEmployeeSalary data:', error);
    return [];
  }
};

export const checkTIN = async (value: string) => {
  console.log('🔥 checkTIN called with CustomerID:', value);
  const regNo = value.trim();
  if (!regNo) {
    console.log('🔥 No regNo, clearing error and returning');
    return { success: false, message: 'No registration number provided' };
  }

  try {
    // First check EBarimt API for company information
    console.log('🔥 Checking EBarimt API first...');
    const API_BASE_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:9002';
    const ebarimtResponse = await fetch(`${API_BASE_URL}/api/check-ebarimt?regno=${regNo}`);
    const ebarimtResult = await ebarimtResponse.json();
    console.log('🔥 EBarimt API response:', ebarimtResult);
    
    // If EBarimt API returns data, populate form fields
    if (ebarimtResult.success && ebarimtResult.data) {
      console.log('🔥 EBarimt data found, but still need to check database...');
      const ebarimtData = ebarimtResult.data;
      
      // Continue with database check even if EBarimt data is available
      console.log('🔥 Checking database for existing customer...');
      const existingResult = await api.get(`/api/customerslist/check-register/${regNo}`);
      
      console.log('🔥 RegisterNo check result:', existingResult);
      
      
      if (existingResult.exists) {
        return { 
          success: true, 
          exists: true, 
          customerData: existingResult.customerData,
          isActive: existingResult.isActive,
          customerOid: existingResult.customerOid
        };
      }
      
      // Return EBarimt data for form population (new customer)
      console.log('🔥 Returning EBarimt data for new customer:', {
        userName: ebarimtResult.name || ebarimtData.name || '',
        tin: ebarimtResult.tin || '',
        vatPayer: ebarimtData.vatPayer || false,
        cityPayer: ebarimtData.cityPayer || false
      });
      return {
        success: true,
        exists: false,
        ebarimtData: {
          userName: ebarimtResult.name || ebarimtData.name || '',
          tin: ebarimtResult.tin || '',
          vatPayer: ebarimtData.vatPayer || false,
          cityPayer: ebarimtData.cityPayer || false
        }
      };
    }
    
    // If EBarimt API didn't return data, continue with database check
    console.log('🔥 EBarimt API did not return data, continuing with database check...');


    
    
    // Then check if RegisterNo already exists in our database
    console.log('🔥 Checking database for existing customer...');
    const existingResult = await api.get(`/api/customerslist/check-register/${regNo}`);
    
    console.log('🔥 RegisterNo check result:', existingResult);
    
    if (existingResult.exists) {
      return { 
        success: true, 
        exists: true, 
        customerData: existingResult.customerData,
        isActive: existingResult.isActive,
        customerOid: existingResult.customerOid
      };
    }

    return { success: true, exists: false };
  } catch (err) {
    console.error('TIN fetch error:', err);
    return { success: false, message: 'Error checking registration number' };
  }
};

// Check director register number
export const checkDirectorRegister = async (value: string) => {
  try {
    if (!value || value.trim().length === 0) {
      return { success: false, message: 'Захирлын регистрийн дугаар оруулна уу' };
    }

    console.log('🔍 Checking director register:', value);
    const response = await api.get(`/api/customerslist/check-director-register/${value.trim()}`);
    
    if (response.success) {
      console.log('✅ Director register check successful:', response.data);
      return { success: true, data: response.data };
    } else {
      console.log('❌ Director register check failed:', response.message);
      return { success: false, message: response.message || 'Захирлын регистрийн дугаар буруу байна' };
    }
  } catch (error) {
    console.error('❌ Error checking director register:', error);
    return { success: false, message: 'Захирлын регистрийн дугаар шалгахад алдаа гарлаа' };
  }
};

// Check user name
export const checkUserName = async (userName: string) => {
  try {
    if (!userName || userName.trim().length === 0) {
      return { success: false, message: 'App хэрэглэгчийн нэр оруулна уу' };
    }

    console.log('🔍 Checking user name:', userName);
    const response = await api.get(`/api/customerslist/check-user-name/${userName.trim()}`);
    
    if (response.success) {
      console.log('✅ User name check successful:', response.data);
      return { success: true, data: response.data };
    } else {
      console.log('❌ User name check failed:', response.message);
      return { success: false, message: response.message || 'App хэрэглэгчийн нэр буруу байна' };
    }
  } catch (error) {
    console.error('❌ Error checking user name:', error);
    return { success: false, message: 'App хэрэглэгчийн нэр шалгахад алдаа гарлаа' };
  }
};

// Populate TIN for edit
export const populateTinForEdit = async (customerId: string) => {
  try {
    console.log('🔍 Populating TIN for edit:', customerId);
    const response = await api.get(`/api/customerslist/customer-tin/${customerId}`);
    
    if (response.success && response.data) {
      console.log('✅ TIN populated for edit:', response.data);
      return response.data;
    } else {
      console.error('❌ Failed to populate TIN for edit:', response);
      return null;
    }
  } catch (error) {
    console.error('❌ Error populating TIN for edit:', error);
    return null;
  }
};

// CustomerEmployeeSalary API functions
export const fetchCustomerEmployeeSalary = async (customerEmployeeId: string, year: number) => {
  try {
    console.log('🔍 Fetching customer employee salary for:', customerEmployeeId, year);
    const response = await api.get(`/api/customer-employee-salary/${customerEmployeeId}/${year}`);
    
    if (response.success && response.data) {
      console.log('✅ Customer employee salary fetched successfully:', response.data);
      return response.data;
    } else {
      console.error('❌ Failed to fetch customer employee salary:', response);
      return null;
    }
  } catch (error) {
    console.error('❌ Error fetching customer employee salary:', error);
    return null;
  }
};

// Fetch all CustomerEmployeeSalary records with customer information
export const fetchAllCustomerEmployeeSalaryWithCustomerInfo = async (year: number) => {
  try {
    console.log('🔍 Fetching all customer employee salary records with customer info for year:', year);
    const response = await api.get(`/api/customer-employee-salary/with-customer-info/${year}`);
    
    if (response.success && response.data) {
      console.log('✅ Customer employee salary with customer info fetched successfully:', response.data.length);
      return response.data;
    } else {
      console.error('❌ Failed to fetch customer employee salary with customer info:', response);
      return [];
    }
  } catch (error) {
    console.error('❌ Error fetching customer employee salary with customer info:', error);
    return [];
  }
};

export const saveCustomerEmployeeSalary = async (salaryData: any) => {
  try {
    console.log('💾 Saving customer employee salary:', salaryData);
    const response = await api.post('/api/customer-employee-salary', salaryData);
    
    if (response.success) {
      console.log('✅ Customer employee salary saved successfully:', response.data);
      return response;
    } else {
      console.error('❌ Failed to save customer employee salary:', response);
      return response;
    }
  } catch (error) {
    console.error('❌ Error saving customer employee salary:', error);
    return {
      success: false,
      message: 'Цалингийн тохиргоо хадгалахад алдаа гарлаа',
      error: error
    };
  }
};

export const updateCustomerEmployeeSalary = async (oid: string, salaryData: any) => {
  try {
    console.log('📝 Updating customer employee salary:', oid, salaryData);
    const response = await api.put(`/api/customer-employee-salary/${oid}`, salaryData);
    
    if (response.success) {
      console.log('✅ Customer employee salary updated successfully:', response.data);
      return response;
    } else {
      console.error('❌ Failed to update customer employee salary:', response);
      return response;
    }
  } catch (error) {
    console.error('❌ Error updating customer employee salary:', error);
    return {
      success: false,
      message: 'Цалингийн тохиргоо шинэчлэхэд алдаа гарлаа',
      error: error
    };
  }
};

// Мэргэжлийн ангиллын жагсаалт авах
export const fetchOccupationCategories = async () => {
  try {
    console.log('🔍 Fetching occupation categories...');
    const response = await api.get('/api/customer-employee-salary/occupation-categories');
    
    if (response.success && response.data) {
      console.log('✅ Occupation categories fetched successfully:', response.data.length);
      return response.data;
    } else {
      console.error('❌ Failed to fetch occupation categories:', response);
      return [];
    }
  } catch (error) {
    console.error('❌ Error fetching occupation categories:', error);
    return [];
  }
};

// Даатгалын ангиллын жагсаалт авах
export const fetchInsureCategories = async () => {
  try {
    console.log('🔍 Fetching insure categories...');
    const response = await api.get('/api/customer-employee-salary/insure-categories');
    
    if (response.success && response.data) {
      console.log('✅ Insure categories fetched successfully:', response.data.length);
      return response.data;
    } else {
      console.error('❌ Failed to fetch insure categories:', response);
      return [];
    }
  } catch (error) {
    console.error('❌ Error fetching insure categories:', error);
    return [];
  }
};

// Цалин бодолт процедур дуудах
export const createPayroll = async (year: number, month: number) => {
  try {
    console.log('💰 Creating payroll calculation:', { year, month });
    const response = await api.post('/api/payroll/create-payroll', {
      year,
      month
    });
    
    if (response.success) {
      console.log('✅ Payroll calculation completed successfully:', response.data);
      return response;
    } else {
      console.error('❌ Failed to create payroll calculation:', response);
      return response;
    }
  } catch (error) {
    console.error('❌ Error creating payroll calculation:', error);
    return {
      success: false,
      message: 'Цалин бодолт процедур дуудахад алдаа гарлаа',
      error: error
    };
  }
};

// Бүх сарын цалин бодолт процедур дуудах
export const createPayrollAllMonths = async (customerOid: string, year: number) => {
  try {
    console.log('💰 Creating payroll calculation for all months:', { customerOid, year });
    const response = await api.post('/api/payroll/create-payroll-all-months', {
      customerOid,
      year
    });
    
    if (response.success) {
      console.log('✅ All months payroll calculation completed successfully:', response.data);
      return response;
    } else {
      console.error('❌ Failed to create all months payroll calculation:', response);
      return response;
    }
  } catch (error) {
    console.error('❌ Error creating all months payroll calculation:', error);
    return {
      success: false,
      message: 'Бүх сарын цалин бодолт процедур дуудахад алдаа гарлаа',
      error: error
    };
  }
};

// Цалин бодолтын статус шалгах
export const getPayrollStatus = async (year: number, month: number) => {
  try {
    console.log('📊 Checking payroll status:', { year, month });
    const response = await api.get(`/api/payroll/payroll-status/${year}/${month}`);
    
    if (response.success) {
      console.log('✅ Payroll status fetched successfully:', response.data);
      return response;
    } else {
      console.error('❌ Failed to fetch payroll status:', response);
      return response;
    }
  } catch (error) {
    console.error('❌ Error fetching payroll status:', error);
    return {
      success: false,
      message: 'Цалин бодолтын статус шалгахад алдаа гарлаа',
      error: error
    };
  }
};

// Бүх ажилчдын цалингийн тохиргоо нэгэн зэрэг хадгалах
export const bulkSaveCustomerEmployeeSalary = async (customerOid: string, year: number, employees: any[]) => {
  try {
    console.log('💾 Bulk saving customer employee salary:', { customerOid, year, employeesCount: employees.length });
    const response = await api.post('/api/customer-employee-salary/bulk-save', {
      customerOid,
      year,
      employees
    });
    
    if (response.success) {
      console.log('✅ Bulk save customer employee salary completed successfully:', response.data);
      return response;
    } else {
      console.error('❌ Failed to bulk save customer employee salary:', response);
      return response;
    }
  } catch (error) {
    console.error('❌ Error bulk saving customer employee salary:', error);
    return {
      success: false,
      message: 'Бүх ажилчдын цалингийн тохиргоо хадгалахад алдаа гарлаа',
      error: error
    };
  }
};

// SalarySheet API ашиглан тооцоолсон цалингийн мэдээлэл авах
export const fetchSalarySheetData = async (year: number, month: number, customerOid: string) => {
  try {
    console.log('🔍 Fetching SalarySheet data for:', customerOid, year, month);

    if (!customerOid) {
      console.error('❌ CustomerOid is required');
      return [];
    }

    const url = `/api/salary-sheet/data/${customerOid}/${year}/${month}`;

    const response = await api.get(url);

    if (response.success && response.data) {
      console.log('✅ SalarySheet data fetched successfully:', response.data.length);
      return response.data;
    } else {
      console.error('❌ Failed to fetch SalarySheet data:', response);
      return [];
    }
  } catch (error) {
    console.error('❌ Error fetching SalarySheet data:', error);
    return [];
  }
};

// Бүх сарын цалингийн нийлбэр авах (ажилчдын дагуу нэгтгэсэн)
export const fetchSalarySheetDataAllMonths = async (year: number, customerOid: string) => {
  try {
    console.log('🔍 Fetching SalarySheet data for all months:', customerOid, year);

    if (!customerOid) {
      console.error('❌ CustomerOid is required');
      return [];
    }

    const url = `/api/salary-sheet/data/${customerOid}/${year}/all-months`;

    const response = await api.get(url);

    if (response.success && response.data) {
      console.log('✅ SalarySheet all months data fetched successfully:', response.data.length);
      return response.data;
    } else {
      console.error('❌ Failed to fetch SalarySheet all months data:', response);
      return [];
    }
  } catch (error) {
    console.error('❌ Error fetching SalarySheet all months data:', error);
    return [];
  }
};


